module.exports = new __parcel__URL__("revitalize.c02316c2.png").toString();